<script></script>

<template>
  <NuxtPwaManifest />
  <div class="container-fluid">
    <slot />
  </div>
</template>
